import { useEffect } from "react";
import { onOpenVerificationPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { useUserStore } from "@/common/store";
import { isPageAllowed, AGE_VERIFICATION_COUNTRIES } from "@/common/utils/geoRules";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { useLocation } from "react-router-dom";

export const useVerification = () => {
  const { pathname } = useLocation();
  const currentUser = useUserStore((state) => state.currentUser);
  const location = useGeolocationStore((state) => state.location);

  useEffect(() => {
    if (!location || !AGE_VERIFICATION_COUNTRIES.includes(location?.country || "")) {
      return;
    }

    if (isPageAllowed(pathname, location)) {
      return;
    }

    if (!currentUser || currentUser.verified) {
      return;
    }

    onOpenVerificationPopup({ user: currentUser });
  }, [currentUser, location, pathname]);
};
